import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export const useGetStarted = () => {
  const { userProfileData } = useSelector((state) => state.userData);
  const [showChangeLogoModal, setShowChangeLogoModal] = useState({});
  const [openWaterMark, setOpenWaterMark] = useState(false);
  const [stepsData, setStepsData] = useState([
    {
      id: 1,
      title: "Upload your logo",
      description: "Files with a maximum size of 2 MB can be uploaded in JPEG and PNG formats.",
      icon_name: "icon-upload",
      type: "logo",
      img: "",
    },
    {
      id: 1,
      title: "Upload your watermark here",
      description: "Files with a maximum size of 2 MB can be uploaded in PNG format",
      icon_name: "icon-watermark",
      type: "waterMark",
      img: "",
    },
  ]);

  // userProfileData.logo_url

  useEffect(() => {
    if (userProfileData?.logo_url || userProfileData?.water_mark_url) {
      let newdata = [...stepsData];
      newdata[0].img = userProfileData?.logo_url;
      newdata[1].img = userProfileData?.water_mark_url;
      setStepsData(newdata);
    }
  }, [userProfileData]);

  const handleOpenModal = (type) => {
    if (type == "logo") {
      let data = {
        title: "Change logo",
        isOpen: true,
        type: "logo",
      };
      setShowChangeLogoModal(data);
    } else {
      // let data = {
      //   title: "Change water mark",
      //   isOpen: true,
      //   type: "waterMark",
      // };
      // setShowChangeLogoModal(data);
      setOpenWaterMark(true);
    }
  };

  const handleCloseModal = () => {
    setShowChangeLogoModal({
      ...showChangeLogoModal,
      isOpen: false,
    });
    setOpenWaterMark(false);
  };

  return {
    openWaterMark,
    stepsData,
    showChangeLogoModal,
    setShowChangeLogoModal,
    setStepsData,
    handleCloseModal,
    handleOpenModal,
  };
};
